import React, { useState, useEffect } from "react";
import { axiosV2 } from "../../../utils/BasicAuthAPI";
import moment from "moment";
import "../audit.css";
import {
  Spin,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
  Tree,
  Switch,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import queryString from "query-string";
import { useParams, useLocation } from "react-router-dom";
import { DownSquareOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import AuditReportViewModal from "../AuditReportView/AuditReportViewModal";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import { useSelector } from "react-redux";

const ViewReportAudit = (props) => {
  const urlCode = useSelector(state => state.urlCode);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [loginError, setLoginError] = useState(false);

  props.setPageHeader("View Audit Report");
  const [SessionReport, setSessionReport] = useState({
    loaded: false,
    data: [],
  });
  const [SessionSummary, setSessionSummary] = useState({
    loaded: false,
    data: null,
  });
  const [clauseModal, setClauseModal] = useState({
    visible: false,
    data: null,
  });
  // let location = useLocation();
  // const params = queryString.parse(location.search);
  let { auditId } = useParams();

  const onTreeNodeSelected = (selectedKeys, e) => {
    if (e.node.extraProps.Actionable && e.node.extraProps.Level) {
      setClauseModal({ visible: true, data: e.node.extraProps });
    }
  };

  const modelCloseHandler = () => {
    setClauseModal({ visible: false, data: null });
  };

  const formatTreeNodes = (data) => {
    
    return data.map((primaryObj) => {
      let pdata = {
        key: primaryObj["_id"],
        extraProps: primaryObj,
        title: (
          <div className={"inlineElement"}>
            <div className={"elem"}>{primaryObj["Clause"]}</div>
            <div className={"elem icon"}>
              {primaryObj["ComplianceSummary"]["St"] === "Open" ? (
                <i className={"fa fa-folder-open"}></i>
              ) : (
                <i className={"fa fa-folder"}></i>
              )}
            </div>
            <div className={"elem redTags colorTag"}>
              {primaryObj["ComplianceSummary"]["R"]}
            </div>
            <div className={"elem yellowTags colorTag"}>
              {primaryObj["ComplianceSummary"]["O"]}
            </div>
            <div className={"elem greenTags colorTag"}>
              {primaryObj["ComplianceSummary"]["G"]}
            </div>
            <div className={"elem grayTags colorTag"}>
              {primaryObj["ComplianceSummary"]["W"]}
            </div>
          </div>
        ),
      };
      if (primaryObj["SubClause"] && primaryObj["SubClause"].length > 0) {
        pdata["children"] = primaryObj["SubClause"].map((secObj) => {
          let sData = {
            key: secObj["_id"],
            extraProps: secObj,
            title: (
              <div className={"inlineElement"}>
                <div className={"elem"}>{secObj["Clause"]}</div>
                <div className={"elem icon"}>
                  {secObj["ComplianceSummary"]["St"] === "Open" ? (
                    <i className={"fa fa-folder-open"}></i>
                  ) : (
                    <i className={"fa fa-folder"}></i>
                  )}
                </div>
                <div className={"elem redTags colorTag"}>
                  {secObj["ComplianceSummary"]["R"]}
                </div>
                <div className={"elem yellowTags colorTag"}>
                  {secObj["ComplianceSummary"]["O"]}
                </div>
                <div className={"elem greenTags colorTag"}>
                  {secObj["ComplianceSummary"]["G"]}
                </div>
                <div className={"elem grayTags colorTag"}>
                  {secObj["ComplianceSummary"]["W"]}
                </div>
              </div>
            ),
          };

          if (secObj["SubClause"] && secObj["SubClause"].length > 0) {
            sData["children"] = secObj["SubClause"].map((tertObj) => {
              return {
                key: tertObj["_id"],
                extraProps: tertObj,
                title: (
                  <div className={"inlineElement"}>
                    <div className={"elem"}>{tertObj["Clause"]}</div>
                    <div className={"elem icon"}>
                      {tertObj["ComplianceSummary"]["St"] === "Open" ? (
                        <i className={"fa fa-folder-open"}></i>
                      ) : (
                        <i className={"fa fa-folder"}></i>
                      )}
                    </div>
                    {tertObj["ComplianceSummary"]["Col"] === "R" ? (
                      <div className={"elem redTags colorTag"}>&nbsp;</div>
                    ) : tertObj["ComplianceSummary"]["Col"] === "G" ? (
                      <div className={"elem greenTags colorTag"}>&nbsp;</div>
                    ) : tertObj["ComplianceSummary"]["Col"] === "O" ? (
                      <div className={"elem yellowTags colorTag"}>&nbsp;</div>
                    ) : tertObj["ComplianceSummary"]["Col"] === "W" ? (
                      <div className={"elem grayTags colorTag"}>&nbsp;</div>
                    ) : null}
                  </div>
                ),
              };
            });
          }
          return sData;
        });
      }
      return pdata;
    });
  };

  const fetchSessionSummary = (userId) => {
    liracrypt
      .get("/audit/sessionsummary", {
        _id: userId,
      })
      .then((res, req) => {
        let data = res.data;
        setSessionSummary({ loaded: true, data: data["Data"] });
      })
      .catch(function (error) {
        console.log("Error****: fetch session summary", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };
  const fetchSessionReport = (userId) => {
    liracrypt
      .get("/audit/sessionreport", {
        _id: userId,
      })
      .then((res, req) => {
        let data = res.data;
        setSessionReport({ loaded: true, data: formatTreeNodes(data["Data"]) });
      })
      .catch(function (error) {
        console.log("Error****: fetch session reprort", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    
    if (auditId) {
      fetchSessionSummary(auditId);
      fetchSessionReport(auditId);
    }
  }, [auditId]);

  if (SessionSummary.loaded) {
    
  }
  return (
    <>
      <SessionError visible={loginError} />
      <div className="AuditSection" style={{ padding: "10px" }}>
        <div className="AuditReport">
          {SessionSummary.loaded && SessionReport.loaded ? (
            <>
              <Row justify="space-around" gutter={24} align="middle">
                <Col span={24}>
                  <h3 className={"title textCenter"}>Audit Report</h3>
                </Col>
              </Row>
              <Row justify="space-around" gutter={24} align="middle">
                <Col span={24}>
                  <Row gutter={24}>
                    <Col span={6}>
                      <div className={"reportLabel subTitle"}>Summary</div>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <div className={"reportLabel"}>
                    <span>Total Clauses</span>
                  </div>
                </Col>
                <Col span={18}>
                  <Row gutter={16}>
                    <Col span={6}>
                      <div className={"grayTags colorTag"}>
                        {SessionSummary.data["TotalClauses"]}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <div className={"reportLabel"}>
                    <span>Audit Completion</span>
                  </div>{" "}
                </Col>
                <Col span={18}>
                  <Row gutter={16} align="middle">
                    <Col span={6}>
                      <div className={"redTags colorTag"}>
                        Pending Clauses :{" "}
                        {SessionSummary.data["AuditStatus_Pending"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"greenTags colorTag"}>
                        Completed Clauses :{" "}
                        {SessionSummary.data["AuditStatus_Completed"]}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <div className={"reportLabel"}>
                    <span>Compliance</span>
                  </div>{" "}
                </Col>
                <Col span={18}>
                  <Row gutter={16} align="middle">
                    <Col span={6}>
                      <div className={"redTags colorTag"}>
                        Non Compliant : {SessionSummary.data["Compliance_R"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"yellowTags colorTag"}>
                        Partial Compliant :{" "}
                        {SessionSummary.data["Compliance_O"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"greenTags colorTag"}>
                        Compliant : {SessionSummary.data["Compliance_G"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"grayTags colorTag"}>
                        Not Audited : {SessionSummary.data["Compliance_W"]}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <div className={"reportLabel"}>
                    <span>Audit Response</span>
                  </div>{" "}
                </Col>
                <Col span={18}>
                  <Row gutter={16} align="middle">
                    <Col span={6}>
                      <div className={"redTags colorTag"}>
                        Pending : {SessionSummary.data["Resp_Pending"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"greenTags colorTag"}>
                        Received : {SessionSummary.data["Resp_Completed"]}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <div className={"reportLabel"}>
                    <span>Countermeasure Status</span>
                  </div>{" "}
                </Col>
                <Col span={18}>
                  <Row gutter={16} align="middle">
                    <Col span={6}>
                      <div className={"redTags colorTag"}>
                        Pending : {SessionSummary.data["CntrMeas_Pending"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"greenTags colorTag"}>
                        Received : {SessionSummary.data["CntrMeas_Completed"]}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <div className={"reportLabel"}>
                    <span>Tasks</span>
                  </div>{" "}
                </Col>
                <Col span={18}>
                  <Row gutter={16} align="middle">
                    <Col span={6}>
                      <div className={"redTags colorTag"}>
                        Pending : {SessionSummary.data["Tasks_Pending"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"greenTags colorTag"}>
                        Completed : {SessionSummary.data["Tasks_Completed"]}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <div className={"reportLabel"}>
                    <span>Clause Closure</span>
                  </div>{" "}
                </Col>
                <Col span={18}>
                  <Row gutter={16} align="middle">
                    <Col span={6}>
                      <div className={"redTags colorTag"}>
                        Open : {SessionSummary.data["ClauseClosure_Pending"]}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className={"greenTags colorTag"}>
                        Close : {SessionSummary.data["ClauseClosure_Completed"]}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row
                className="Clauses"
                justify="space-around"
                gutter={24}
                align="middle"
              >
                <Col span={24}>
                  <Row gutter={24}>
                    <Col span={6}>
                      <div className={"reportLabel subTitle"}>Clauses</div>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={20} offset={4}>
                      <Tree
                        switcherIcon={<DownSquareOutlined />}
                        treeData={SessionReport.data}
                        defaultExpandAll={false}
                        onSelect={onTreeNodeSelected}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div
                className={"usermanagement textCenter"}
                style={{ marginTop: "30px" }}
              >
                <Link to={`v02/${urlCode}/audit-list`} className="nextBtn">
                  <Button
                    type="danger"
                    htmlType="button"
                    className="login-form-button gx-mt-1 bigBtn"
                  >
                    <span className="gx-link"> Back to Audit Session</span>
                  </Button>
                </Link>
              </div>
              <AuditReportViewModal
                visible={clauseModal.visible}
                clauseObj={clauseModal.data}
                modelCloseHandler={modelCloseHandler}
              />
            </>
          ) : (
            <div className="Loading">
              <Spin indicator={antIcon} tip="Loading..." />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewReportAudit;
